import { render, staticRenderFns } from "./scope-of-application.vue?vue&type=template&id=3c5a41de&scoped=true"
import script from "./scope-of-application.vue?vue&type=script&lang=js"
export * from "./scope-of-application.vue?vue&type=script&lang=js"
import style0 from "./scope-of-application.vue?vue&type=style&index=0&id=3c5a41de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5a41de",
  null
  
)

export default component.exports